import React from "react";
import DataList from "components/datatable/DataList";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import { RuleRequired } from "utils/MyUtils";
import { showEmpty } from "features/kms/system/SystemPageUtils";

export const monthOptions = [
  { id: 1, nama: "Januari" },
  { id: 2, nama: "Februari" },
  { id: 3, nama: "Maret" },
  { id: 4, nama: "April" },
  { id: 5, nama: "Mei" },
  { id: 6, nama: "Juni" },
  { id: 7, nama: "Juli" },
  { id: 8, nama: "Agustus" },
  { id: 9, nama: "September" },
  { id: 10, nama: "Oktober" },
  { id: 11, nama: "November" },
  { id: 12, nama: "Desember" },
];

export function PersonalEducationTable({ baseUrl = "/profile/pendidikan" }) {
  const [, , , axiosFetch] = useAxiosFunction();
  const [pendidikanResp] = useAxios({ method: "GET", url: "/references/pendidikan", auth: true });
  const pendidikanOptions = Array.isArray(pendidikanResp?.data) ? pendidikanResp.data : [];
  const currentYear = new Date().getFullYear();
  const normalizedBaseUrl = String(baseUrl || "/profile/pendidikan").replace(/\/$/, "");

  const coltype = {
    id_riwayat_pendidikan: { type: "hidden", name: "id_riwayat_pendidikan" },
    id_pendidikan: {
      label: "Jenjang Pendidikan",
      type: "dropdown",
      name: "id_pendidikan",
      colsize: 12,
      validation: RuleRequired,
      options: pendidikanOptions,
      valueId: "id_pendidikan",
      labelId: "nama",
      placeholder: "-Pilih Jenjang Pendidikan-",
      width: 180,
    },
    jenjang_pendidikan: {
      label: "Jenjang Pendidikan",
      renderFunc: (val) => showEmpty(val),
      width: 180,
    },
    program_studi: {
      label: "Program Studi",
      type: "text",
      name: "program_studi",
      colsize: 12,
      renderFunc: (val) => showEmpty(val),
      width: 180,
    },
    nama_institusi: {
      label: "Nama Institusi",
      type: "text",
      name: "nama_institusi",
      colsize: 12,
      validation: RuleRequired,
      renderFunc: (val) => showEmpty(val),
      width: 220,
    },
    alamat: {
      label: "Alamat",
      type: "textarea",
      name: "alamat",
      colsize: 12,
      renderFunc: (val) => showEmpty(val),
      width: 160,
    },
    tahun_lulus: {
      label: "Tahun Lulus",
      type: "number",
      name: "tahun_lulus",
      colsize: 6,
      validation: {
        required: "Wajib diisi",
        min: { value: 1900, message: "Tahun Lulus tidak valid" },
        max: { value: currentYear + 10, message: "Tahun Lulus tidak valid" },
      },
      width: 70,
      align: "center",
    },
    bulan_lulus: {
      label: "Bulan Lulus",
      type: "dropdown",
      name: "bulan_lulus",
      colsize: 6,
      validation: RuleRequired,
      options: monthOptions,
      valueId: "id",
      labelId: "nama",
      placeholder: "-Pilih Bulan Lulus-",
      width: 90,
      align: "center",
    },
    bulan_lulus_name: {
      label: "Bulan Lulus",
      renderFunc: (val) => showEmpty(val),
      width: 90,
      align: "center",
    },
    action: { label: "Aksi", align: "center", width: 80 },
  };

  const formColumns = [
    "id_pendidikan",
    "program_studi",
    "nama_institusi",
    "alamat",
    "tahun_lulus",
    "bulan_lulus",
  ];

  const saveHandle = async (form, defaultValue = {}) => {
    const id = form?.id_riwayat_pendidikan || defaultValue?.id_riwayat_pendidikan || "";
    return axiosFetch({
      method: id ? "PUT" : "POST",
      url: id ? `${normalizedBaseUrl}/${id}` : normalizedBaseUrl,
      auth: true,
      data: {
        id_pendidikan: Number(form?.id_pendidikan || 0),
        program_studi: form?.program_studi || "",
        nama_institusi: form?.nama_institusi || "",
        alamat: form?.alamat || "",
        tahun_lulus: Number(form?.tahun_lulus || 0),
        bulan_lulus: Number(form?.bulan_lulus || 0),
      },
    });
  };

  return (
    <DataList
      title="Pendidikan"
      coltype={coltype}
      dlist={{
        url: normalizedBaseUrl,
        columns: [
          "no",
          "jenjang_pendidikan",
          "program_studi",
          "nama_institusi",
          "alamat",
          "tahun_lulus",
          "bulan_lulus_name",
          "action",
        ],
        filter: null,
        sort_by: [
          "jenjang_pendidikan",
          "program_studi",
          "nama_institusi",
          "tahun_lulus",
          "bulan_lulus",
        ],
      }}
      addconfig={{
        columns: formColumns,
        title: "Tambah Riwayat Pendidikan",
        label_tool: "Tambah Riwayat Pendidikan",
        saveHandle,
      }}
      editconfig={{
        columns: ["id_riwayat_pendidikan", ...formColumns],
        title: "Ubah Riwayat Pendidikan",
        url: normalizedBaseUrl,
        urlitem: normalizedBaseUrl,
        cellid: "id_riwayat_pendidikan",
        saveHandle,
      }}
      delconfig={{
        url: normalizedBaseUrl,
        cellid: "id_riwayat_pendidikan",
        cellname: "nama_institusi",
      }}
      pdflist={{ title: "Pendidikan", orientation: "landscape" }}
      xlslist={{ title: "Pendidikan" }}
    />
  );
}

export default function PersonalEducationHistoryPage() {
  return <PersonalEducationTable />;
}
